import React, {FC, ReactElement} from 'react';
import {Slide} from '@mui/material';
import Box from '@mui/material/Box';

//TYPES
type SlideTransitionProps = {
  children: ReactElement,
  width: number,
  show: boolean
};

const SlideTransition: FC<SlideTransitionProps> = ({children, width, show}) => {
  return <Slide direction="right" in={show} mountOnEnter unmountOnExit>
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: width
      }}
    >
      {children}
    </Box>
  </Slide>;
};
export default SlideTransition;